var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9381 4.82785L12.9381 17.2582C12.9381 18.781 12.3332 20.2415 11.2564 21.3183C10.1796 22.3951 8.71918 23 7.19637 23C5.67355 23 4.21311 22.3951 3.13632 21.3183C2.05953 20.2415 1.45459 18.781 1.45459 17.2582L1.45459 4.82785C1.45459 3.81264 1.85788 2.83901 2.57574 2.12115C3.2936 1.40329 4.26723 1 5.28244 1C6.29765 1 7.27128 1.40329 7.98914 2.12115C8.707 2.83901 9.11029 3.81264 9.11029 4.82785L9.10353 17.265C9.10353 17.7726 8.90189 18.2594 8.54295 18.6183C8.18402 18.9773 7.69721 19.1789 7.1896 19.1789C6.682 19.1789 6.19518 18.9773 5.83625 18.6183C5.47732 18.2594 5.27568 17.7726 5.27568 17.265L5.28244 5.7882",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOption);
export default __webpack_public_path__ + "static/media/MoreOption.b4a3f99b9c7365a9c71662a4b8e9c514.svg";
export { ForwardRef as ReactComponent };